export default "__VITE_ASSET__DruHKSJm__"